import qs from 'qs'

/**
 *
 * @export - 下载流文件
 * @param {*} res - axios返回的响应，带响应头
 */
export function downloadFile(res) {
  let downLoadUrl = ''
  const binaryData = [res.data]
  try {
    downLoadUrl = URL.createObjectURL(new Blob(binaryData))
  } catch (error) {
    console.log(error)
  }

  let disposition = res.headers['content-disposition'].split(';')[1]
  let obj = qs.parse(disposition)
  createDownloadElement(downLoadUrl, obj.filename)
  URL.revokeObjectURL(downLoadUrl)
}

/**
 *
 * @export - 创建一个待下载链接的A标签并下载
 * @param {*} url 绝对路径与相对路径
 * @param {*} fileName 下载文件的文件名称
 */
export function createDownloadElement(url, fileName) {
  let a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  a = null
}
